import { useNavigate } from "react-router-dom";

const SadScreen = () => {
  const navigate = useNavigate();
  console.log("dskhgdhk");
  return (
    <section id="screen-sad" className="screen">
      {/* Rain Background */}
      <div className="sad-background">
        <div
          className="rain-drop"
          style={{ "--x": "10%", "--delay": "0s" }}
        ></div>
        <div
          className="rain-drop"
          style={{ "--x": "20%", "--delay": "0.3s" }}
        ></div>
        <div
          className="rain-drop"
          style={{ "--x": "35%", "--delay": "0.6s" }}
        ></div>
        <div
          className="rain-drop"
          style={{ "--x": "50%", "--delay": "0.9s" }}
        ></div>
        <div
          className="rain-drop"
          style={{ "--x": "65%", "--delay": "1.2s" }}
        ></div>
        <div
          className="rain-drop"
          style={{ "--x": "80%", "--delay": "1.5s" }}
        ></div>
        <div
          className="rain-drop"
          style={{ "--x": "90%", "--delay": "1.8s" }}
        ></div>
      </div>
      {/* Sad Content */}
      <div className="sad-content">
        <div className="sad-heart-container">
          {/* Broken Heart */}
          <div className="broken-heart">
            <svg viewBox="0 0 100 100" className="heart-svg">
              <defs>
                <linearGradient
                  id="sadHeartGrad"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor="#FF6B6B" />
                  <stop offset="100%" stopColor="#DC143C" />
                </linearGradient>
              </defs>
              <path
                d="M50 85C50 85 10 55 10 30C10 15 25 5 40 10C47 12 50 20 50 20C50 20 53 12 60 10C75 5 90 15 90 30C90 55 50 85 50 85Z"
                fill="url(#sadHeartGrad)"
              />
            </svg>
          </div>

          {/* Sad Face */}
          <div className="sad-face">
            <div className="tear tear-left"></div>
            <div className="tear tear-right"></div>

            <div className="sad-eyes">
              <div className="eye">
                <div className="pupil"></div>
              </div>
              <div className="eye">
                <div className="pupil"></div>
              </div>
            </div>

            <div className="sad-mouth"></div>
          </div>
        </div>

        <h2 className="sad-title">Could you please think...</h2>
        <p className="sad-subtitle">My heart is breaking and feeling heavy💔</p>

        {/* Try Again Button */}
        <button
          id="btn-try-again"
          className="btn btn-retry"
          onClick={() => navigate("/")}
        >
          <span className="btn-icon">🥺</span>
          <span className="btn-text">Try Again</span>
          <div className="hearts-float">
            <span>💕</span>
            <span>💖</span>
            <span>💝</span>
          </div>
        </button>
      </div>
    </section>
  );
};

export default SadScreen;
